var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuCoach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coach",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.715,
    height: 21.867,
    viewBox: "0 0 22.715 21.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53245",
    "data-name": "Group 53245",
    transform: "translate(3.151 0.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53241",
    "data-name": "Group 53241",
    transform: "translate(1.415 13.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24606",
    "data-name": "Path 24606",
    d: "M109.729,322.266a2.83,2.83,0,0,0-2.83,2.83v4.246a.708.708,0,0,0,.708.708h5.66l.708-.288.707.288h5.66a.708.708,0,0,0,.708-.708V325.1a2.83,2.83,0,0,0-2.83-2.83h-.708l-3.538,1.061-3.538-1.061Z",
    transform: "translate(-106.899 -322.266)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53240",
    "data-name": "Group 53240",
    transform: "translate(10.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53239",
    "data-name": "Group 53239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24607",
    "data-name": "Path 24607",
    d: "M349.97,322.266h-.982a2.83,2.83,0,0,1,2.829,2.83v4.246a.708.708,0,0,1-.708.708h.982a.708.708,0,0,0,.708-.708V325.1A2.83,2.83,0,0,0,349.97,322.266Z",
    transform: "translate(-348.988 -322.266)",
    fill: "#9e037c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53242",
    "data-name": "Group 53242",
    transform: "translate(4.953 13.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24608",
    "data-name": "Path 24608",
    d: "M256,362h1.415v6.086H256Z",
    transform: "translate(-253.171 -360.303)",
    fill: "#cfd7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24609",
    "data-name": "Path 24609",
    d: "M196.81,322.266a3.537,3.537,0,0,1-1.911,3.142.355.355,0,0,1-.385-.036l-1.242-.984-1.242.984a.355.355,0,0,1-.385.036,3.537,3.537,0,0,1-1.911-3.142Z",
    transform: "translate(-189.734 -322.266)",
    fill: "#f3f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24610",
    "data-name": "Path 24610",
    d: "M297.772,322.265a3.533,3.533,0,0,1-1.545,2.923l.232.183a.355.355,0,0,0,.384.036,3.537,3.537,0,0,0,1.911-3.142h-.982Z",
    transform: "translate(-291.679 -322.265)",
    fill: "#cfd7e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53243",
    "data-name": "Group 53243",
    transform: "translate(3.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24611",
    "data-name": "Path 24611",
    d: "M181.456,11.932V9.624A2.123,2.123,0,0,1,183.579,7.5h3.538a2.123,2.123,0,0,1,2.123,2.123v2.308Z",
    transform: "translate(-180.285 -7.501)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24612",
    "data-name": "Path 24612",
    d: "M222.872,11.932V9.624a2.123,2.123,0,1,1,4.245,0v2.308Z",
    transform: "translate(-219.932 -7.501)",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24613",
    "data-name": "Path 24613",
    d: "M291.924,7.5h-.984a2.123,2.123,0,0,1,2.123,2.123v2.308h.984V9.623A2.123,2.123,0,0,0,291.924,7.5Z",
    transform: "translate(-285.093 -7.5)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24614",
    "data-name": "Path 24614",
    d: "M261.5,7.5a2.127,2.127,0,0,0-.494.058,2.123,2.123,0,0,1,1.629,2.064v2.308h.988V9.623A2.123,2.123,0,0,0,261.5,7.5Z",
    transform: "translate(-256.437 -7.5)",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24615",
    "data-name": "Path 24615",
    d: "M227.116,272.566v2.122a2.123,2.123,0,0,1-4.245,0v-2.123Z",
    transform: "translate(-219.931 -261.245)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24616",
    "data-name": "Path 24616",
    d: "M157.313,142.861a.708.708,0,0,1-.708-.708v-1.415a.708.708,0,0,1,.708-.708H165.8a.708.708,0,0,1,.708.708v1.415a.708.708,0,0,1-.708.708Z",
    transform: "translate(-156.495 -134.371)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24617",
    "data-name": "Path 24617",
    d: "M349.954,140.033h-.982a.708.708,0,0,1,.708.708v1.415a.708.708,0,0,1-.708.708h.982a.708.708,0,0,0,.708-.708v-1.415A.708.708,0,0,0,349.954,140.033Z",
    transform: "translate(-340.646 -134.373)",
    fill: "#ffa27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24618",
    "data-name": "Path 24618",
    d: "M189.738,113.737v3.615a3.538,3.538,0,1,0,7.075,0v-3.615l-3.538-.354Z",
    transform: "translate(-188.213 -108.861)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24619",
    "data-name": "Path 24619",
    d: "M163.987,92.527a.7.7,0,0,1-.877.162,9.039,9.039,0,0,0-8.032,0,.7.7,0,0,1-.877-.162l0,0a.708.708,0,0,1,.2-1.075,10.458,10.458,0,0,1,9.394,0,.708.708,0,0,1,.2,1.075Z",
    transform: "translate(-154.031 -86.795)",
    fill: "#9e037c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24620",
    "data-name": "Path 24620",
    d: "M266.26,91.448a9.637,9.637,0,0,0-4.7-1.114c-.168,0-.331,0-.491.011a9.455,9.455,0,0,1,4.206,1.1.708.708,0,0,1,.2,1.075l0,0a.7.7,0,0,1-.068.07c.062.032.12.063.174.092a.7.7,0,0,0,.877-.162l0,0A.708.708,0,0,0,266.26,91.448Z",
    transform: "translate(-256.5 -86.796)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53244",
    "data-name": "Group 53244",
    transform: "translate(11.561 9.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24621",
    "data-name": "Path 24621",
    d: "M421.667,263.666h1.415V265.9h-1.415Z",
    transform: "translate(-418.369 -262.631)",
    fill: "#736b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24622",
    "data-name": "Path 24622",
    d: "M407.589,240.848h-2.147a.342.342,0,0,1-.342-.342v-.732a.342.342,0,0,1,.342-.342h2.147a.342.342,0,0,1,.342.342v.732A.342.342,0,0,1,407.589,240.848Z",
    transform: "translate(-402.51 -239.433)",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24623",
    "data-name": "Path 24623",
    d: "M441.349,239.433h-.982a.342.342,0,0,1,.342.342v.732a.342.342,0,0,1-.342.342h.982a.342.342,0,0,0,.342-.342v-.732A.342.342,0,0,0,441.349,239.433Z",
    transform: "translate(-436.27 -239.433)",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_779",
    "data-name": "Ellipse 779",
    cx: 2.83,
    cy: 2.83,
    r: 2.83,
    transform: "translate(0 5.661) rotate(-45)",
    fill: "#f3f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24624",
    "data-name": "Path 24624",
    d: "M427.225,305.7a2.844,2.844,0,0,0-.491.043,2.83,2.83,0,0,1,0,5.574,2.83,2.83,0,1,0,.491-5.617Z",
    transform: "translate(-423.22 -302.87)",
    fill: "#cfd7e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24625",
    "data-name": "Path 24625",
    d: "M76.618,278.976l.855-1.045a.354.354,0,0,0-.024-.474l-.524-.524a.354.354,0,0,0-.5,0l-2.231,2.231a1.434,1.434,0,0,0-.049,1.994,1.415,1.415,0,0,0,2.35-1.478A.714.714,0,0,1,76.618,278.976Z",
    transform: "translate(-73.766 -265.326)",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24626",
    "data-name": "Path 24626",
    d: "M97.986,277.457l-.524-.524a.354.354,0,0,0-.5,0l-.241.241.283.283a.354.354,0,0,1,.024.474l-.855,1.045a.713.713,0,0,0-.122.7,1.415,1.415,0,0,1-.831,1.833,1.416,1.416,0,0,0,1.814-1.833.713.713,0,0,1,.122-.7l.855-1.045A.354.354,0,0,0,97.986,277.457Z",
    transform: "translate(-94.303 -265.327)",
    fill: "#ffbe40"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53246",
    "data-name": "Group 53246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24627",
    "data-name": "Path 24627",
    d: "M232.258,166.661a.32.32,0,0,0,.32-.32v-.354a.32.32,0,0,0-.641,0v.354A.32.32,0,0,0,232.258,166.661Z",
    transform: "translate(-222.032 -158.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24628",
    "data-name": "Path 24628",
    d: "M298.525,166.661a.32.32,0,0,0,.32-.32v-.354a.32.32,0,0,0-.641,0v.354A.32.32,0,0,0,298.525,166.661Z",
    transform: "translate(-285.469 -158.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24629",
    "data-name": "Path 24629",
    d: "M261.923,50.02a.32.32,0,0,0-.32-.32h-.354a.32.32,0,0,0,0,.641h.354a.32.32,0,0,0,.32-.32Z",
    transform: "translate(-249.785 -47.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24630",
    "data-name": "Path 24630",
    d: "M251.661,208.079a1.032,1.032,0,0,0,.89-.513.32.32,0,1,0-.554-.321.387.387,0,0,1-.671,0,.32.32,0,0,0-.554.321A1.032,1.032,0,0,0,251.661,208.079Z",
    transform: "translate(-240.019 -198.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24631",
    "data-name": "Path 24631",
    d: "M85.372,15.886a3.155,3.155,0,0,0-2.123-2.977v-.948H83.3a.663.663,0,0,0,.662-.662v-.732a.663.663,0,0,0-.662-.662H81.148a.663.663,0,0,0-.662.662V11.3a.663.663,0,0,0,.662.662h.046v.948a3.151,3.151,0,0,0-1.062.623,3.158,3.158,0,0,0-.74-.088h-1.8V11.795a3.855,3.855,0,0,0,1.4-2.664h.4A1.029,1.029,0,0,0,80.419,8.1V6.688a1.023,1.023,0,0,0-.11-.462A1.028,1.028,0,0,0,80,4.692c-.187-.1-.4-.212-.641-.319V2.443A2.443,2.443,0,0,0,76.915,0H73.377a2.446,2.446,0,0,0-2.443,2.443V4.374c-.24.106-.453.215-.641.319a1.028,1.028,0,0,0-.311,1.534,1.023,1.023,0,0,0-.109.462V8.1A1.029,1.029,0,0,0,70.9,9.131h.4a3.855,3.855,0,0,0,1.4,2.664v1.649H70.9a3.162,3.162,0,0,0-.595.057l.3-.372a.672.672,0,0,0-.045-.9l-.524-.524a.675.675,0,0,0-.953,0l-2.231,2.231a1.762,1.762,0,0,0-.055,2.44,1.722,1.722,0,0,0,.948.515v3.953a1.029,1.029,0,0,0,1.028,1.028h1.693a.32.32,0,0,0,0-.641H68.778a.388.388,0,0,1-.387-.387V16.884a1.721,1.721,0,0,0,.9-.477,1.738,1.738,0,0,0,.394-1.847.364.364,0,0,1-.023-.148,2.5,2.5,0,0,1,1.239-.327h.4a3.846,3.846,0,0,0,2.07,3.106.677.677,0,0,0,.731-.069l.015-.012v4.117H71.752a.32.32,0,1,0,0,.641h9.762a1.029,1.029,0,0,0,1.028-1.028V19.021a3.155,3.155,0,0,0,2.83-3.134Zm-16.535.067a1.095,1.095,0,0,1-1.57-.022,1.117,1.117,0,0,1,.042-1.547l2.231-2.231a.034.034,0,0,1,.047,0l.524.524a.033.033,0,0,1,0,.045l-.855,1.045a1.057,1.057,0,0,0-.185.337l0,.009a1.017,1.017,0,0,0,.015.674A1.1,1.1,0,0,1,68.838,15.953ZM81.127,11.3v-.732a.021.021,0,0,1,.021-.021H83.3a.021.021,0,0,1,.021.021V11.3a.021.021,0,0,1-.021.021H81.148A.021.021,0,0,1,81.127,11.3Zm.708.662h.774v.8a3.055,3.055,0,0,0-.774,0v-.8Zm-5.924,4.122a2.449,2.449,0,0,0,1.657-2h.78a3.208,3.208,0,0,1-1.722,2.538.035.035,0,0,1-.038,0ZM79.779,8.1a.388.388,0,0,1-.387.387H79v-2h0a1.021,1.021,0,0,0,.758.094.389.389,0,0,1,.013.1V8.1ZM76.915.641a1.8,1.8,0,0,1,1.8,1.8V4.119A9.656,9.656,0,0,0,77.589,3.8V2.443a2.437,2.437,0,0,0-.8-1.8ZM73.344,3.675V2.443a1.8,1.8,0,1,1,3.6,0V3.675a11.883,11.883,0,0,0-3.6,0ZM71.575,2.443a1.8,1.8,0,0,1,1.8-1.8H73.5a2.437,2.437,0,0,0-.8,1.8V3.8a9.658,9.658,0,0,0-1.128.322ZM70.41,5.522a.389.389,0,0,1,.194-.27,10.14,10.14,0,0,1,9.083,0,.388.388,0,0,1,.108.591l0,0a.378.378,0,0,1-.475.087,9.356,9.356,0,0,0-8.343,0,.378.378,0,0,1-.475-.087l-.005-.006A.385.385,0,0,1,70.41,5.522Zm.1,2.581V6.688a.387.387,0,0,1,.013-.1,1.02,1.02,0,0,0,.758-.094h0v2H70.9a.388.388,0,0,1-.387-.387Zm1.415.708V6.188a9,9,0,0,1,6.435,0V8.811a3.217,3.217,0,1,1-6.435,0Zm3.217,3.858a3.834,3.834,0,0,0,1.8-.448v1.531s0,.008,0,.012,0,.005,0,.008a1.8,1.8,0,0,1-3.6,0s0,0,0,0,0,0,0-.005V12.221A3.835,3.835,0,0,0,75.146,12.669Zm-1.441,3.95a.035.035,0,0,1-.038,0,3.208,3.208,0,0,1-1.722-2.538h.78a2.449,2.449,0,0,0,1.656,2Zm1.054-.017.387-.307.387.307v4.625h-.774ZM82.222,18.4a2.487,2.487,0,0,1-1.518-.511.32.32,0,1,0-.388.51,3.117,3.117,0,0,0,1.585.625v1.819a.388.388,0,0,1-.387.387h-5.34V17.109l.015.012a.677.677,0,0,0,.731.069,3.846,3.846,0,0,0,2.07-3.106h.4c.08,0,.16,0,.24.012a3.148,3.148,0,0,0-.227,3.2.32.32,0,0,0,.572-.288,2.484,2.484,0,0,1-.265-1.125,2.51,2.51,0,1,1,2.51,2.51Z",
    transform: "translate(-63.505 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24632",
    "data-name": "Path 24632",
    d: "M432.116,332.749h-.741v-1.095a.32.32,0,0,0-.641,0v1.415a.32.32,0,0,0,.32.32h1.061a.32.32,0,0,0,0-.641Z",
    transform: "translate(-412.338 -317.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24633",
    "data-name": "Path 24633",
    d: "M2.056,348.22a.32.32,0,0,0-.32-.32H.32a.32.32,0,0,0,0,.641H1.735A.32.32,0,0,0,2.056,348.22Z",
    transform: "translate(0 -333.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24634",
    "data-name": "Path 24634",
    d: "M36.738,414.208l-1.226.708a.32.32,0,1,0,.32.555l1.226-.708a.32.32,0,0,0-.32-.555Z",
    transform: "translate(-33.842 -396.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24635",
    "data-name": "Path 24635",
    d: "M35.512,265.663l1.226.708a.32.32,0,0,0,.32-.555l-1.226-.708a.32.32,0,0,0-.32.555Z",
    transform: "translate(-33.842 -253.744)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCoach);
export default __webpack_public_path__ + "static/media/menu-coach.3756c266e7403e014162054b997a0f1b.svg";
export { ForwardRef as ReactComponent };